export enum DocumentationItemType {
    TEXT = "text",
    IMAGE = "image",
    FILE = "file",
    CODE = "code",
    LINK = "link",
    LAYOUT = "layout",
    TEST_DOCUMENT = "test_document"
}

export interface DocumentationItem {
    id: number;
    documentation_id: number;
    type: DocumentationItemType;
    content: string | null;
    description: string | null;
    title: string | null;
    file_path: string | null;
    order: number;
    created_at: string;
    updated_at: string;
}

export interface Documentation {
    id: number;
    project_id: number;
    title: string;
    description?: string;
    created_by: number;
    created_at: string;
    updated_at: string;
    items: DocumentationItem[];
}

export interface DocumentationCreate {
    title: string;
    description?: string;
    items?: DocumentationItemCreate[];
}

export interface DocumentationUpdate {
    title?: string;
    description?: string;
    items?: DocumentationItemUpdate[];
}

export interface DocumentationItemCreate {
    type: DocumentationItemType;
    content?: string;
    description?: string;
    title?: string;
    file_path?: string;
    order?: number;
}

export interface DocumentationItemUpdate {
    type?: DocumentationItemType;
    content?: string;
    description?: string;
    title?: string;
    file_path?: string;
    order?: number;
} 